import { Box, Button } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { addFile } from "./productGroupSetupSlice";
import AttachmentIcon from "@mui/icons-material/Attachment";
import { useRef } from "react";

export default function FileUpload() {
   const autherization = localStorage.getItem("data");
	const data = JSON.parse(autherization);
	let setAccess = true;
	if (data?.restrictedAccess == 0) setAccess = true;
	else setAccess = false;
	const isRestrictedAccess = setAccess;
   const inputRef = useRef(null);
   const dispatch = useDispatch();

   function handleInputClick() {
      inputRef.current.click();
   }

   function uploadFile(event) {
      for (let i = 0; i < event.target.files.length; ++i) {
         const file = event.target.files[i];
         dispatch(addFile(file));
      }
   }

   return (
      <Box>
         <input hidden type="file" multiple={true} ref={inputRef} onChange={uploadFile} />

         <Button
            startIcon={<AttachmentIcon />}
            sx={{
               bgcolor: "blue.main",
               color: "white.main",
               textTransform: "none",
               fontWeight: "bold",
               // mt: -5,
               "&:hover": {
                  bgcolor: "skyBlue.main",
                  color: "black.main",
               },
               marginLeft: "calc(100% - 155px)",
            }}
            disabled = {!isRestrictedAccess}
            onClick={handleInputClick}
         >
            Attach File
         </Button>
      </Box>
   );
}
